<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
             <el-form-item label="轮询名称：">
                <el-input v-model.trim="searchForm.name" @keyup.enter.native="getListHandler" placeholder="支持模糊搜索" clearable></el-input>
            </el-form-item>

              <el-form-item label="通道名称：">
                <el-input v-model.trim="searchForm.supplierName" @keyup.enter.native="getListHandler" placeholder="支持模糊搜索" clearable></el-input>
            </el-form-item>
            
            <el-form-item class="btnArea">
                <el-button type="primary"  plain icon="el-icon-search" @click="getListHandler($event)" >查 询</el-button>

                 <el-button type="primary"  plain  @click="showEditDialog(null)" >新 增 轮 询</el-button>
            </el-form-item>
        </el-form>


        <el-table :data="tbpg.tableData"
		 border
		 fit
		 highlight-current-row
		 style="width: 100%;"
		 :header-cell-style="{background:'#f5f5f5'}"
		 :default-sort = "{prop: 'createTime', order: 'descending'}">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="name" label="轮询名称" width="180" align="center"></el-table-column>
              <el-table-column  align="center"  label="轮询备注"  width="120" >
                 <template v-slot="scope">
                    <el-tooltip  :content="scope.row.remark">
                        <p > {{scope.row.remark}}</p>
                    </el-tooltip>
                </template>
            </el-table-column> 
            <el-table-column prop="threadSize" label="线程数" width="80" align="center"></el-table-column>
               <el-table-column prop="sleepTime" label="轮询间隔/秒" width="90" align="center"></el-table-column>
            <el-table-column  align="center"  label="轮询类型"  width="160">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.type==1"  :content="scope.row.typeName">
                        <p style="color:green"> {{scope.row.typeName}}</p>
                    </el-tooltip>
                     <el-tooltip v-else-if="scope.row.type==2"  :content="scope.row.typeName" >
                        <p style="color:green"> {{scope.row.typeName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else  :content="scope.row.typeName">
                        <p style="color:crimson"> {{scope.row.typeName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>

              <el-table-column  align="center"  label="通道名称"  >
                 <template v-slot="scope">
                    <el-tooltip  :content="scope.row.supplierNames">
                        <p > {{scope.row.supplierNames}}</p>
                    </el-tooltip>
                </template>
            </el-table-column> 

             <!-- <el-table-column  align="center"  label="轮询状态"  width="100">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.state==0"  :content="scope.row.stateName">
                        <p style="color:green"> {{scope.row.stateName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else  :content="scope.row.stateName">
                        <p style="color:crimson"> {{scope.row.stateName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column> -->

             <el-table-column prop="createTime" label="创建时间" width="160"  align="center"></el-table-column> 

            <el-table-column label="操作" align="center" width="160">
                <template slot-scope="scope">
                    <el-button @click="showEditDialog(scope.row)" type="text" size="small" >编辑</el-button>
                    <el-button @click="toTaskInfoList(scope.row.name)" type="text" size="small" >轮询详情</el-button>
                    <el-button @click="deleteTask(scope.row.id)" type="text" style="color: red;" size="small" >删除</el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 



     <el-dialog :append-to-body="true"  title="配置轮询" :visible.sync="editVisibale"  width="600px"  class="notifyDetail" :close-on-click-modal="false" @close="cancel()">
         
            <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="140px">
                <el-form-item label="轮询名称：" prop="name">
                    <el-input v-model="editForm.name" placeholder="15个文字以内"  clearable></el-input>
                </el-form-item>

                <el-form-item label="轮询备注：" prop="remark">
                    <el-input v-model="editForm.remark" placeholder="选填"  clearable></el-input>
                </el-form-item>

                <el-form-item label="轮询线程数：" prop="threadSize">
                    <el-input v-model="editForm.threadSize" placeholder="建议线程数1~5个（选填，联通和电信建议设置1）"  clearable></el-input>
                </el-form-item>
                 <el-form-item label="轮询间隔：" prop="sleepTime">
                    <el-input v-model="editForm.sleepTime" placeholder="轮询卡的间隔时间 / 秒（选填,联通和电信建议设置1）"  clearable></el-input>
                </el-form-item>

               <el-form-item label="轮询类型：" rop="type"> 
                <el-select v-model="editForm.type" clearable>
                    <el-option label="轮询所有卡" :value="0"></el-option>
                    <el-option label="轮询在用套餐的卡" :value="1"></el-option>
                    <el-option label="轮询购买过套餐的卡" :value="2"></el-option>
                </el-select>
              </el-form-item>
               
                <el-form-item label="选择通道：" rop="supplierCodes"> 
                    <el-select v-model="editForm.supplierCodes" multiple  filterable 
                    placeholder="请选择" style="width: 80%;">
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                    <el-button  @click="editForm.supplierCodes.length == branchSupplierOption.length?cancelChooseAll():chooseAll()" style="width: 18%; float: right;">
                        {{editForm.supplierCodes.length == branchSupplierOption.length?"取消全选":"全 选"}}
                    </el-button>
                </el-form-item>
                  <!-- <el-form-item label="轮询状态：" prop="state">
                   <el-radio-group v-model="editForm.state">
                    <el-radio :label="0">启用</el-radio>
                    <el-radio :label="1">禁用</el-radio>
                  </el-radio-group>
                </el-form-item> -->
              <p>备注（必看）：</p>
              <p style="color:red">1：不建议同个通道配置多个轮询规则，避免重复轮询占用资源</p>
              <p style="color:green">2：建议同个轮询规则配置多个通道，减少服务器线程占用</p>
              <p style="color:green">3：建议非流量池卡只轮询有在用套餐的卡,并全部放同一个规则里面</p>
              <p style="color:green">4：建议电信和联通的流量池一个通道设置一个轮询规则，可减少运营商接口限制</p>
              <p style="color:green">5：新增轮询规则后 会不间断轮询通道里面的卡。
                <t style="color:red">不用的通道请及时禁用掉！</t>
              </p>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel()">取 消</el-button>
                <el-button type="primary" @click="confirmHandler()">确 定</el-button>
            </div>
        </el-dialog>       
        
    </div>
</template>
<script>
import common from '@/utils/common.js';
export default {
    data(){
        return {
           


            editRules: {
                 name: { required: true, message: '请输入轮训名称', trigger: 'blur' },
                 type: {required: true, message: '请输入轮询类型', trigger: 'blur'},
                 supplierCodes: {required: true, message: '请输入轮询通道', trigger: 'blur'}
            },
            confirmExportDialogVisible:false,
            searchForm: {
                name: '',
                supplierName: ''
               
            },
            branchSupplierOption: [],//运营商字典
            editVisibale: false,
            editForm:{
                id: "",
                sleepTime:"",
                name: "",
                remark: "",
                type:"",
                threadSize:"",
                state:"0",
                supplierCodes: [],
                supplierNames: "",
            },

            branchSupplierOption:[],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            //批量操作
            dialogVisible: false,
            limitForm:{
                supplierCode: null,
                limitSpeed: null,
            },
            statusGroup: [],
            limitFormRules:{
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            },
            //批量操作  end

            //单卡限速操作
            singleLimitDialog: false,
            singleLimitForm:{
                iccid: null,
                limitSpeed: null,
            },
            singleLimitFormRules:{
                iccid:[
                    { required: true, message: '请输入iccid', trigger: 'blur' }
                ],
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
         toTaskInfoList(name){
                this.$store.commit('menu/setFluxPollDetailIccid', name);
                this.$store.commit('menu/setFluxPollDetailTaskNo', "");
             if (!this.$store.state.menu.isFluxPollDetailTab) {
                let newTab = {
                        label: '轮询详情',
                        index: 'fluxPollDetail',
                        closable: true,
                        component: "views/monitor/taskInfoList"
                    }
                this.$store.commit('menu/addTab', newTab);
                this.$store.commit('menu/setIsFluxPollDetailTab', true);
            }
            this.$store.commit('menu/switchTab', 'fluxPollDetail')
        },
        deleteTask(id){
            var data={
                id:id
            }
            this.$confirm("删除后将不会再执行此轮询配置，正在执行的轮询 会执行完毕。确定要删除操作吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
               
             common.sysRequest('lunxun/delete/task',data, 'post').then(res => {
                if(res.data.code == 200){
                     this.$message.success(res.data.message);
                     this.getListHandler();
                }else{
                    this.$message.error(res.data.message);
                }
            })
                
            })
        },
         showEditDialog(data){
            common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
            if(data){
                this.editForm = data;
                this.editForm.supplierCodes = Array.isArray(data.supplierCodes)?data.supplierCodes:data.supplierCodes.split("，");
            }else{
                this.editForm = {
                     id: "",
                   name: "",
                   remark: "",
                  type:"",
                  threadSize:"",
                  state:"",
                  supplierCodes: [],
                  supplierNames: "",
                };
            }
            this.editVisibale = true;
        },
        chooseAll(){
            let val = [];
            for(let i in this.branchSupplierOption){
                val.push(this.branchSupplierOption[i].id);
            }
            this.editForm.supplierCodes = val;
        },
        cancelChooseAll(){
            this.editForm.supplierCodes = [];
        },

        confirmHandler(){
            this.$refs.editForm.validate(valid => {
                if(valid) {
                    var d = {
                        ...this.editForm
                    }
                    d.supplierNames = "";
                    for(let j=0; j<d.supplierCodes.length; j++){
                        for(let i=0; i<this.branchSupplierOption.length; i++){
                            if(this.branchSupplierOption[i].id == d.supplierCodes[j]){
                                d.supplierNames += this.branchSupplierOption[i].name + '(' + this.branchSupplierOption[i].alias + ')，';
                                break;
                            }
                        }
                    }
                    d.supplierCodes = d.supplierCodes.join("，");
                    if(d.supplierNames.lastIndexOf('，') == d.supplierNames.length-1){
                        d.supplierNames = d.supplierNames.substring(0, d.supplierNames.length-1);
                    }
                    let path = "lunxun/add/task";
                    if(d.id && d.id!=""){
                       path =  "lunxun/update/task"
                    }
                    common.sysRequest(path, d, 'post').then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.cancel();
                            this.getListHandler();
                            
                        }else{
                           this.$message.error(res.data.message); 
                        }
                    })
                }
            });
        },

        cancel(){
            this.editForm = {
                     id: "",
                   name: "",
                   remark: "",
                  type:"",
                  threadSize:"",
                  state:"",
                  supplierCodes: [],
                  supplierNames: "",
                };
            this.editVisibale = false;
        },

         goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('lunxun/select/all/task/page', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getListHandler();
        },


        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if(fileList.length > 1){
                fileList.splice(0,1);
            }
            
        },
        sureRechargeHandler(){
            if (this.$refs.uploadFile.uploadFiles.length == 0) {
                this.$message.error('请选择文件');
                return;
            }
            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    this.$refs.uploadFile.submit();   
                    this.rechargeVisible = false; 
                } 
            });              
        },

        handleSuccess(res){
            if(res.code == 200){
                this.getListHandler();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.uploadFile.clearFiles();
        },

       

        formatLimitSpeed(code){

            let v =  this.statusGroup.filter(function(item){
                if(code == item.code){
                    return item;
                }
            });
            return v[0]&&v[0].description?v[0].description:"";
        },
        

        singleLimitSpeed(){
            let data = new FormData();
            Object.keys(this.singleLimitForm).forEach((key) => {
                data.append(key, this.singleLimitForm[key]);
            });

            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    common.sysRequest("sim/price/limit/speed", data, 'post').then(res=>{
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.getListHandler();
                            this.cancelsSngleLimit();
                        }else{
                            this.$message.error(res.data.message)
                        }     
                    }).catch(err=> console.error(err));
                } 
            });   
            
        },

        cancelsSngleLimit(){
            this.singleLimitForm.limitSpeed = null;
            this.singleLimitForm.iccid = null;
            this.singleLimitDialog = false;
        },
    },

    computed:{
        
    },

    created () {
        this.getListHandler();

        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');

        //获取状态值
        common.sysRequest('pkg/all/pkgType', {}, 'get').then(res => {
            if(res.data.code == 200){
                this.branchSupplierOption = res.data.data;
            }
        })
    },
}
</script>
<style lang="less" scoped>

</style>

